
<template>
    <div>
        <el-dialog @close="closeDialog" :visible.sync="dialogVisibleM" :modal-append-to-body="false" width="1000px"
            height="66vh" class="add-label-dialog" :close-on-click-modal="false">
            <template #title>
                <h1 class="pop-title">{{ titleName }} </h1> <span
                    class="title-row">知识集内容会上传至企微官方服务器，可以被AI助手引用，用于生成回复内容</span>
            </template>
            <div v-loading="loading" class="pupop-container">
                <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" class="demo-ruleForm"
                    style="overflow: auto;max-height: 55vh;">
                    <el-form-item label="知识集名称" prop="kbName">
                        <el-input style="width: 360px;" size="small" clearable v-model="formData.kbName" show-word-limit
                            :maxlength="20" placeholder="请输入知识集名称"></el-input>
                    </el-form-item>
                    <el-form-item label="知识集内容" prop="docList">
                        <span class="content-title">可添加下列内容，总数不超过1000条</span>
                        <div class="content-btn-row">
                            <div class="content-btn">
                                <el-upload ref="uploadFileItem" :multiple="true" class="upload-demo" :action="sendUrl"
                                    :headers="headers" :show-file-list="false" :disabled="progressVisible"
                                    :accept="fileTypeArr.join(',')" :on-progress="handleProgress"
                                    :before-upload="beforeUploadFile" :on-success="handleFileSuccess" :on-error="onError">
                                    <h3 :class="[{ 'disabled-h': progressVisible }]" @click="addBtn(1)"><el-image
                                            class="start-icon" :src="require('@/assets/img/content-btn1.png')">
                                        </el-image>本地文件</h3>
                                </el-upload>
                                <p>60MB以内，pdf/doc/docx/xlsx</p>
                                <el-progress v-if="progressVisible" :stroke-width="10" :show-text="false"
                                    :percentage="progressV"></el-progress>
                            </div>
                            <div class="content-btn">
                                <h3 @click="addBtn(2)"><el-image class="start-icon"
                                        :src="require('@/assets/img/content-btn2.svg')">
                                    </el-image>网页链接</h3>
                                <p>可以公开访问的网页</p>
                            </div>
                            <div class="content-btn">
                                <el-upload ref="uploadFileItem" class="upload-demo" :action="sendUrl" :headers="headers"
                                    :disabled="progressVisible2" :show-file-list="false" :multiple="true"
                                    :accept="fileTypeArr2.join(',')" :on-progress="handleProgress2"
                                    :before-upload="beforeUploadFile2" :on-success="handleFileSuccess2"
                                    :on-error="onError2">
                                    <h3 :class="[{ 'disabled-h': progressVisible2 }]" @click="addBtn(3)"><el-image
                                            class="start-icon" :src="require('@/assets/img/content-btn3.png')">
                                        </el-image>标准问答对</h3>
                                </el-upload>
                                <p>通过模板上传xlsx格式文件，<span @click="addBtn(4)">下载模板</span></p>
                                <el-progress v-if="progressVisible2" :stroke-width="10" :show-text="false"
                                    :percentage="progressV2"></el-progress>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
                <div class="table-area">
                    <el-table size="medium" :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                        ref="singleTable" v-loading="loadingTable" :highlight-current-row="true" :data="formData.docList"
                        height="36vh" style="width: 100%;height:100%;font-size: 13px">
                        <el-table-column label="序号" width="65" align="center">
                            <template slot-scope="scope">
                                {{ tableParams.size * (tableParams.page - 1) + (scope.$index + 1) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="内容" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                {{ scope.row.webUrl || scope.row.docName }}
                            </template>

                        </el-table-column>
                        <el-table-column prop="status" label="状态" width="150"  align="center">
                            <template v-slot="spo">
                                <span v-if="spo.row.status == 0" style="color: #00A870;" class="span-status">
                                    <i class="el-icon-circle-check"></i>添加成功</span>
                                <span v-else-if="spo.row.status == 1" style="color: #E34D59;" class="span-status">
                                    <i class="el-icon-circle-close"></i>添加失败</span>
                                <span v-else-if="spo.row.status == 2" style="color: #417FF9;" class="span-status">
                                    <i class="el-icon-upload2"></i>添加中</span>
                                <span v-else-if="spo.row.status == -1"> 待提交</span>
                                <span v-else>--</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="operation" label="操作" width="120" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" style="color: red;"
                                    @click="deleteRow(scope.row, scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;margin-top: 10px;">
                    <el-button type="primary" size="small" @click="confirmWeicome()">保存</el-button>
                    <el-button size="small " @click="closeDialog" style="margin-right:20px"> 取 消</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog @close="closeDialogWeb" v-if="dialogVisibleWeb" :visible.sync="dialogVisibleWeb" title="添加网页数据"
            :modal-append-to-body="false" width="700px" height="60vh" class="add-label-dialog"
            :close-on-click-modal="false">
            <div class="web-container">
                <div class="title-row-w">
                    <el-image class="img-left" :src="require('@/assets/img/content-btn2.svg')">
                    </el-image>
                    <div class="right">
                        <p><span></span>网页知识暂不支持自动更新，如需更新知识请重新上传</p>
                        <p><span></span>承诺填写的网址合法，公开且已获合法授权，使用网站网址不会违反法律规定及侵犯他人合法权益</p>
                    </div>
                </div>
                <el-form :model="formDataWeb" :rules="rulesWeb" ref="formRefWeb" label-width="0px" class="demo-ruleForm"
                    style="overflow: auto;max-height: 35vh;">
                    <div v-for="(item, index) in formDataWeb.urls" :key="index" class="form-row">
                        <div class="index-row">
                            <span>{{ index + 1 }}</span>
                        </div>
                        <el-form-item style="flex: 1;margin: 0;" label="" :prop="'urls.' + index + '.url'" :rules="[{
                            validator: checkUrl, required: true, trigger: 'blur', currentIndex: index
                        }]">
                            <el-input style="width: 100%;" size="small" v-model="item.url"
                                placeholder="请输入或黏贴以https://或 http://开头的链接"></el-input>
                        </el-form-item>
                        <i v-if="!(formDataWeb.urls && formDataWeb.urls.length == 1)" class="el-icon-delete"
                            @click="delWeb(index)"></i>
                    </div>
                </el-form>
            </div>
            <div class="btn-row">
                <div :class="['btn-content', { 'disabled-btn': formDataWeb.urls && formDataWeb.urls.length >= 200 }]"
                    @click="addWeb">
                    <span>+</span>
                    添加链接
                </div>
            </div>
            <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;margin-top: 10px;">
                <el-button type="primary" size="small" @click="confirmWeicomeWeb()">确定</el-button>
                <el-button size="small " @click="closeDialogWeb" style="margin-right:20px">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    knowledgeDetailApi, createKnowledgeApi, updateKnowledgeDocApi
} from "@/api/knowledgeSet.js";
export default {
    // 新建sop任务弹框
    name: "addEditPopup",
    components: {
    },
    props: {
        titleName: {
            type: String,
            default: "",
        },
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        currentRow: {
            type: Object,
            default: null,
        },
        currentPopupType: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            /**是否时编辑 */
            isEdit: false,
            formRef: null,
            dialogVisibleM: false,
            rules: {
                kbName: [
                    { required: true, message: '请输入知识集名称', trigger: 'blur' },
                    { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                ],
                docList: [
                    { required: true, message: '知识集内容不能为空', trigger: 'change' },
                ],
            },
            formData: {
                kbId: null,
                kbName: "",
                docList: [],
                /**编辑的时候  新增的内容 */
                addDocList: [],
                /**编辑的时候  删除的内容 */
                delDocList: [],
            },
            loadingTable: false,
            loading: false,
            showMyUpload: false,
            upLoadData: null,

            tableParams: {
                page: 1, //当前页码
                size: 10, //每页条数
            },
            /**本地文件类型 */
            fileTypeArr: ['.pdf', '.doc', '.docx', '.xlsx'],
            /**标准问答对文件类型 */
            fileTypeArr2: ['.xlsx'],
            progressV: 0, // 上传进度值
            progressV2: 0, // 上传进度值
            progressVisible: false,
            progressVisible2: false,
            headers: {
                authorization: localStorage.getItem("Authorization"),
            },
            sendUrl: this.$baseUrl + "/api/knowledge/doc/uploadToZone",
            /**上传的文件列表 */
            fileList: [],
            total: 0,
            pageSizes: [10, 20, 50, 100, 200, 500],

            formDataWeb: {
                urls: [{ url: '' }]
            },
            formRefWeb: null,
            rulesWeb: {
            },
            dialogVisibleWeb: false,
            showMessage: true,
            showMessage2: true,
        }
    },

    watch: {
        dialogVisible: {
            handler(newVal, oldVal) {
                console.log("监听 dialogVisible", newVal);
                this.dialogVisibleM = newVal
                if (newVal) {
                    // this.initFunc();
                }
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
    },
    mounted() {
        console.log('mounted', this.currentRow);
        if (this.currentPopupType == 'edit') {
            if (!this.currentRow.kbId) {
                return this.$message.warning('kbId不能为空');

            }
            this.getDetais()
        } else {
            this.showMyUpload = true
        }
    },
    methods: {

        /**校验url*/
        checkUrl(rule, value, callback) {
            if ((value || value === 0) && !/^https?:\/\//.test(value)) {
                callback(new Error('请输入https://或 http://开头的链接'));
            } else {
                callback()
            }
        },
        /**添加知识集内容 val*/
        addBtn(val) {
            console.log('添加知识集内容', val,);
            switch (val) {
                case 1:
                    // 本地文件
                    break;
                case 2:
                    // 网页链接
                    this.dialogVisibleWeb = true
                    break;
                case 3:
                    // 标准问答对
                    break;
                case 4:
                    // 下载模板
                    this.download(
                        "/api/knowledge/doc/exportExcel",
                        `问答对格式知识文档模板.xlsx`,
                        {},
                        localStorage.getItem("Authorization"),
                        "",
                        "get"
                    );
                    break;

                default:
                    break;
            }

            this.showAddEditPopup = true
        },
        /**上传进度 */
        handleProgress(event) {
            console.log('上传进度', event);
            if (event && event.percent) {
                this.progressVisible = true; // 显示进度条
                this.progressV = Math.round(event.percent); // 更新进度值，注意这里是百分比值，所以乘以100并四舍五入为整数。
                if (this.progressV >= 100) {
                    setTimeout(() => {
                        this.progressVisible = false
                        this.progressV = 0
                    }, 100);
                }
            } else {
                this.progressVisible = false
                this.progressV = 0
            }
        },
        // 上传之前
        beforeUploadFile(file) {
            const isLtM = file.size / 1024 / 1024 < 60; // 限制大小
            // const currentType = file && file.name && !file.name.indexOf('.') != -1 ? file.name.split('.')[1] : ''
            const splitName = file.name.indexOf('.') != -1 ? file.name.split('.') : ''
            const currentType = splitName ? file.name.split('.')[splitName.length - 1] : ''
            console.log('上传文件之前', file, currentType);
            if (
                !currentType || (!this.fileTypeArr.some(v => { return v.indexOf(currentType) != -1 }))
            ) {
                this.$message.error(`上传文件的格式只能是 ${this.fileTypeArr.join('、')} 格式!`);
                return false;
            }
            if (!isLtM) {
                this.$message.error("上传文件大小不能超过 60MB!");
                return false;
            }
            // this.showLoading();
            return true;
        },
        handleFileSuccess(res, file) {
            console.log("handleFileSuccess", res, file);
            if (res.error.code == 200) {
                const objM = {
                    fileMediaId: res.data.mediaId,
                    docName: file.name,
                    type: this.handleType(file.name),
                    status: -1
                }
                this.pushTable(objM)
            } else {
                if (this.showMessage) {
                    this.showMessage = false
                    this.$message({
                        type: 'warning',
                        duration: 3000,
                        message: res.error.message
                    });
                    setTimeout(() => {
                        this.showMessage = true
                    }, 3000);
                }
            }
        },
        onError(res, type) {
            console.log('onError', res, type);
            //   setTimeout(() => {
            //     this.hideLoading();
            //   }, 200);
            this.$message.error("上传失败，请重试！");
        },

        handleType(fileName) {
            let res = null
            // fileTypeArr: ['.pdf', '.doc', '.docx', '.xlsx'],
            if (fileName.indexOf('xlsx') != -1) {
                res = 4
            } else if (fileName.indexOf('docx') != -1) {
                res = 6
            } else if (fileName.indexOf('doc') != -1) {
                res = 5
            } else if (fileName.indexOf('pdf') != -1) {
                res = 2
            } else {
                res = 101
            }
            return res
        },

        /**上传进度 */
        handleProgress2(event) {
            console.log('上传进度2', event);
            if (event && event.percent) {
                this.progressVisible2 = true; // 显示进度条
                this.progressV2 = Math.round(event.percent); // 更新进度值，注意这里是百分比值，所以乘以100并四舍五入为整数。
                if (this.progressV2 >= 100) {
                    setTimeout(() => {
                        this.progressVisible2 = false
                        this.progressV2 = 0
                    }, 100);
                }
            } else {
                this.progressVisible2 = false
                this.progressV2 = 0
            }
        },
        // 上传之前
        beforeUploadFile2(file) {
            const isLtM = file.size / 1024 / 1024 < 20; // 限制大小
            const splitName = file.name.indexOf('.') != -1 ? file.name.split('.') : ''
            const currentType = splitName ? file.name.split('.')[splitName.length - 1] : ''
            console.log('上传文件之前2', file, currentType);
            if (
                !currentType || (!this.fileTypeArr2.some(v => { return v.indexOf(currentType) != -1 }))
            ) {
                this.$message.error(`上传文件的格式只能是 ${this.fileTypeArr2.join('、')} 格式!`);
                return false;
            }
            if (!isLtM) {
                this.$message.error("上传文件大小不能超过 20MB!");
                return false;
            }
            // this.showLoading();
            return true;
        },
        handleFileSuccess2(res, file) {
            console.log("handleFileSuccess2", res, file);
            if (res.error.code == 200) {
                const objM = {
                    fileMediaId: res.data.mediaId,
                    docName: file.name,
                    type: this.handleType(file.name),
                    status: '待提交'
                }
                this.pushTable(objM)
            } else {
                if (this.showMessage2) {
                    this.showMessage2 = false
                    this.$message({
                        type: 'warning',
                        duration: 3000,
                        message: res.error.message
                    });
                    setTimeout(() => {
                        this.showMessage2 = true
                    }, 3000);
                }
            }
        },
        onError2(res, type) {
            console.log('onError', res, type);
            //   setTimeout(() => {
            //     this.hideLoading();
            //   }, 200);
            this.$message.error("上传失败，请重试！");
        },
        /**添加数据到表格 */
        pushTable(item) {
            if (this.formData.docList && this.formData.docList.length >= 1000) {
                return this.$message.warning("添加失败！内容总数不超过1000条")
            }
            this.formData.docList.push(item)
            if (this.currentPopupType == 'edit') {
                this.formData.addDocList.push({
                    ...item,
                    indexM: this.formData.docList.length - 1
                })
            }
        },

        /**删除表格一行 */
        deleteRow(row, index) {
            console.log('deleteRow', row, index);
            if (this.currentPopupType == 'edit') {
                if (row.docId) {
                    this.formData.delDocList.push(JSON.parse(JSON.stringify(row.docId)))
                } else {
                    // 当前新增的 还没提交的 删除
                    this.formData.addDocList = this.formData.addDocList.filter(v => {
                        return v.indexM != index
                    })
                }
            }
            this.formData.docList.splice(index, 1)
        },

        paginateArray(arr) {
            // 计算开始索引和结束索引
            const startIndex = (this.tableParams.page - 1) * this.tableParams.size;
            const endIndex = startIndex + this.tableParams.size;
            // 使用Array.from方法获取新的数组
            return Array.from(arr).slice(startIndex, endIndex);
        },

        /**添加网页数据 */
        addWeb() {
            if (this.formDataWeb.urls && this.formDataWeb.urls.length >= 200) {
                return this.$message.warning("添加失败！单次支持不超过200条链接")
            }
            this.formDataWeb.urls.push({ url: '' })
        },
        /**删除添加网页数据 */
        delWeb(index) {
            this.formDataWeb.urls.splice(index, 1)
        },
        /**关闭添加网页 */
        closeDialogWeb() {
            this.dialogVisibleWeb = false
            this.formDataWeb.urls = [{ url: '' }]
        },
        /**确定添加网页 */
        confirmWeicomeWeb() {
            this.$refs.formRefWeb.validate((valid) => {
                if (valid) {
                    if (!(this.formDataWeb.urls.some(v => { return v.url }))) {
                        return this.$message.warning("保存失败！至少有一条数据不为空")
                    }
                    const copyData = JSON.parse(JSON.stringify(this.formDataWeb.urls))
                    console.log('submit', copyData);
                    copyData.forEach(v => {
                        if (v.url) {
                            this.pushTable({
                                docName: '',
                                webUrl: v.url,
                                type: 101,
                                status: '待提交'
                            })
                        }
                    })
                    this.closeDialogWeb()
                } else {
                    console.log('error submit!!', this.formDataWeb,);
                    return false;
                }
            });
        },


        /**编辑的时候 获取详情 */
        async getDetais() {
            this.loading = true
            const res = await knowledgeDetailApi({ kbId: this.currentRow.kbId }, localStorage.getItem("Authorization"))
            this.loading = false
            if (res.error.code == 200) {
                this.formData.kbId = res.data.kbId
                this.formData.kbName = res.data.kbName
                res.data.docList.forEach(v => {
                    // switch (v.status) {
                    //     case 0:
                    //         v.status = '添加成功'
                    //         break;
                    //     case 1:
                    //         v.status = '添加失败'
                    //         break;
                    //     case 2:
                    //         v.status = '添加中'
                    //         break;
                    //     default:
                    //         break;
                    // }
                })
                this.formData.docList = res.data.docList
            }
        },
        /**关闭 */
        closeDialog(reset) {
            this.$emit('update:dialogVisible', false)
            if (reset) {
                this.$emit('getData')

            }
        },

        /**确定 */
        confirmWeicome() {
            this.$refs.formRef.validate(async (valid) => {
                if (valid) {
                    if (this.progressVisible || this.progressVisible2) {
                        return this.$message.warning("有文件正在上传，请上传完成后再试")
                    }
                    let paramsObj = {}
                    if (this.currentPopupType == 'edit') {
                        paramsObj = {
                            "kbId": this.formData.kbId,
                            "kbName": this.formData.kbName,
                            "addDocList": this.formData.addDocList,
                            "delDocList": this.formData.delDocList
                        }
                    } else {
                        paramsObj = {
                            "kbName": this.formData.kbName,
                            "docList": this.formData.docList
                        }
                    }
                    console.log('submit', this.formData, paramsObj);
                    this.loading = true
                    if (this.currentPopupType == 'edit') {
                        const res = await updateKnowledgeDocApi(paramsObj, localStorage.getItem("Authorization"))
                        this.loading = false
                        if (res.error.code == 200) {
                            this.$message.success("保存成功!");
                            this.closeDialog(true);
                        }
                    } else {
                        const res2 = await createKnowledgeApi(paramsObj, localStorage.getItem("Authorization"))
                        this.loading = false
                        if (res2.error.code == 200) {
                            this.$message.success("知识集创建成功!");
                            this.closeDialog(true);
                        }
                    }
                } else {
                    console.log('error submit!!', this.formData,);
                    return false;
                }
            });


        }
    },

};
</script>
<style lang="scss" scoped>
.pop-title {
    list-style: none;
    display: contents;
    color: #3D4757;
    font-size: 18px;
    font-weight: 400;

}

.title-row {
    color: #86909C;
    font-size: 14px;
    font-weight: 400;
    margin-left: 8px;
}

.pupop-container {
    display: flex;
    flex-direction: column;

    .demo-ruleForm {
        // height: 200px;
        // overflow: hidden;
    }

    .table-area {
        height: calc(66vh - 200px - 80px);
    }

    .staff-pagination {
        height: 40px;
        display: flex;
        justify-content: flex-end;
    }
}

.content-title {
    color: #ED7B2F;
    font-size: 14px;
    font-weight: 400;
}

.content-btn-row {
    display: flex;
    gap: 20px;

    .content-btn {
        position: relative;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        padding: 12px 0;
        width: 252px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .upload-demo {
            height: 28px;
            line-height: 28px;
        }

        .disabled-h:hover {
            cursor: not-allowed !important;
        }

        h3 {
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
            list-style: none;
            margin: 0;
            padding: 0;
            font-size: 16px;
            color: #2684FF;
            text-decoration: underline;
            width: fit-content;
            margin: auto;

            &:hover {
                cursor: pointer;
            }

            .start-icon {
                width: 28px;
                height: 28px;
            }
        }

        p {
            color: #909399;
            font-size: 14px;
            font-weight: 400;
            margin: 0;
            height: 22px;
            line-height: 22px;
        }

        span {
            color: #2684FF;
            font-size: 14px;
            font-weight: 400;
            text-decoration: underline;

            &:hover {
                cursor: pointer;
            }
        }


        .el-progress {
            position: absolute;
            bottom: 0px;
            width: 100%;
        }
    }
}

.web-container {
    background-color: rgba(245, 247, 250, 1);
    padding: 20px;
    border-radius: 8px;

    .title-row-w {
        display: flex;
        gap: 20px;
        padding: 20px;
        background-color: #fff;
        border-radius: 8px;
        box-sizing: border-box;

        .img-left {
            width: 68px;
            height: 68px;
        }

        .right {
            flex: 1;
            display: flex;
            flex-direction: column;

            p {
                font-size: 14px;
                color: #606266;
                line-height: 22px;
                margin: 0;

                span {
                    vertical-align: middle;
                    display: inline-block;
                    margin-right: 6px;
                    line-height: 22px;
                    height: 6px;
                    width: 6px;
                    border-radius: 100%;
                    background-color: #78BBFF;
                }
            }
        }
    }

    .demo-ruleForm {
        background-color: #fff;
        border-radius: 8px;
        padding: 20px;
        margin-top: 20px;
        box-sizing: border-box;

        .form-row {
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 16px;

            :deep(.el-form-item) {
                margin-bottom: 0;
            }

            :deep(.el-form-item__content) {
                margin-left: 0;
            }

            .index-row {
                width: 36px;
                height: 36px;
                background-image: url('../../../assets/img/index-icon.png');
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;

                span {
                    display: block;
                    line-height: 36px;
                    width: 30px;
                    text-align: center;
                    margin-left: 2px;
                    height: 100%;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(12, 111, 146, 0.8);
                }
            }

            .el-icon-delete {
                width: 32px;
                height: 32px;
                border: 1px solid #D9D9D9;
                text-align: center;
                line-height: 32px;
                border-radius: 4px;
                font-size: 20px;
                color: #E34D59;
            }
        }
    }

}

.btn-row {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    border: 1px solid rgba(245, 247, 250, 1);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

    .disabled-btn {
        cursor: no-drop !important;
    }

    .btn-content {
        display: flex;
        justify-content: center;
        align-items: center;
        color: rgba(78, 89, 105, 1);
        font-size: 14px;

        &:hover {
            cursor: pointer;
        }

        span {
            text-align: center;
            line-height: 20px;
            display: block;
            width: 20px;
            height: 20px;
            border-radius: 999px;
            color: #fff;
            background-color: rgba(38, 132, 255, 1);
            margin-right: 8px;
            font-size: 20px;
        }

    }
}

.span-status {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
    font-size: 14px;
    i {
        font-size: 14px;
    }
}
</style>
  